import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'shoppingcart.title',
    defaultMessage: '购物车',
  },
  clear: {
    id: 'shoppingcart.clear',
    defaultMessage: '清空购物车',
  },
  clearConfirmed: {
    id: 'shoppingcart.clearConfirmed',
    defaultMessage: '您确定要清空购物车吗？',
  },
  commercialClosed: {
    id: 'shoppingcart.commercialClosed',
    defaultMessage: '商户已打烊',
  },
  isEmpty: {
    id: 'shoppingcart.isEmpty',
    defaultMessage: '购物车是空的',
  },
  closeOk: {
    id: 'shoppingcart.closeOk',
    defaultMessage: '选好啦',
  },
  chosen: {
    id: 'shoppingcart.chosen',
    defaultMessage: '选好了',
  },
  needDeliveryFee: {
    id: 'shoppingcart.needDeliveryFee',
    defaultMessage: '另需配送费{currency}{shipmentFee}',
  },
  freeDeliveryFee: {
    id: 'shoppingcart.freeDeliveryFee',
    defaultMessage: '已免{currency}{shipmentFee}配送费',
  },
  man: {
    id: 'shoppingCart.man',
    defaultMessage: '先生',
  },
  woman: {
    id: 'shoppingCart.woman',
    defaultMessage: '女士',
  },
  anonymous: {
    id: 'shoppintCart.anonymous',
    defaultMessage: '匿名用户',
  },
  totalOfDishes: {
    id: 'shoppingCart.totalOfDishes',
    defaultMessage: '共 {dishesCount} 份',
  },
  dishNameTotalOfDishes: {
    id: 'shoppingCart.dishNameTotalOfDishes',
    defaultMessage: '{dishTypeName} {dishesCount}份',
  },
  totalPrice: {
    id: 'shoppingCart.totalPrice',
    defaultMessage: '总计',
  },
  isEmptyAndGetDish: {
    id: 'shoppingCart.isEmptyAndGetDish',
    defaultMessage: '购物车空空的呢，快去点餐吧～',
  },
  customerImg: {
    id: 'shoppingCart.customerImg',
    defaultMessage: '用户头像',
  },
  notes: {
    id: 'shoppingCart.notes',
    defaultMessage: '备注',
  },
  peopleCountOfMeal: {
    id: 'shoppingCart.peopleCountOfMeal',
    defaultMessage: '就餐人数',
  },
  peopleCount: {
    id: 'shoppingCart.peopleCount',
    defaultMessage: '人数',
  },
  changeShoppingCart: {
    id: 'shoppingCart.changeShoppingCart',
    defaultMessage: '购物车内容被修改啦',
  },
  looking: {
    id: 'shoppingCart.looking',
    defaultMessage: '快去看看吧～',
  },
  isAddOrder: {
    id: 'shoppingCart.isAddOrder',
    defaultMessage: '当前桌台存在订单，是否直接加菜?',
  },
  func: {
    id: 'shoppingCart.func',
    defaultMessage: '功能',
  },
  addDish: {
    id: 'shoppingCart.addDish',
    defaultMessage: '加菜',
  },
  backShoppingCart: {
    id: 'shoppingCart.backShoppingCart',
    defaultMessage: '返回购物车',
  },
  success: {
    id: 'shoppingCart.success',
    defaultMessage: '下单成功！',
  },
  known: {
    id: 'shoppingCart.known',
    defaultMessage: '朕知道了',
  },
  checkoutMoney: {
    id: 'shoppingCart.checkoutMoney',
    defaultMessage: '结账',
  },
  checkoutMoneyForBar: {
    id: 'shoppingCart.checkoutMoneyForBar',
    defaultMessage: '去吧台结账',
  },
  checkoutMoneyForBarReason: {
    id: 'shoppingCart.checkoutMoneyForBarReason',
    defaultMessage: '当前显示价格仅为参考总价，最终以吧台结账信息为准',
  },
  placedOrder: {
    id: 'shoppingCart.placeOrder',
    defaultMessage: '已下单',
  },
  mineCoupons: {
    id: 'shoppingCart.mineCoupons',
    defaultMessage: '优惠券',
  },
  confirmOrder: {
    id: 'shoppingCart.confirmOrder',
    defaultMessage: '确认下单',
  },
  confirmPay: {
    id: 'shoppingCart.confirmPay',
    defaultMessage: '确认买单',
  },
  confirmPayDesc: {
    id: 'shoppingCart.confirmPayDesc',
    defaultMessage: '若有其他优惠，将在付款时抵扣',
  },
  placeOnOrder: {
    id: 'shoppingCart.placeOnOrder',
    defaultMessage: '下单',
  },
  shopConfirm: {
    id: 'shoppingCart.shopConfirm',
    defaultMessage: '商户确认',
  },
  eatting: {
    id: 'shoppingCart.eatting',
    defaultMessage: '就餐',
  },
  scanPlaceOrder: {
    id: 'shoppingCart.scanPlaceOrder',
    defaultMessage: '扫码下单',
  },
  selectTablePlaceOrder: {
    id: 'shoppingCart.selectTablePlaceOrder',
    defaultMessage: '选桌下单',
  },
  confirmTable: {
    id: 'shoppingCart.confirmTable',
    defaultMessage: '确认桌台',
  },
  minimumConsumptionReminder: {
    id: 'shoppingCart.minimumConsumptionReminder',
    defaultMessage: '本桌最低消费{lowerValue}元，还差{value}元',
  },
  pleaseChooseTable: {
    id: 'shoppingCart.pleaseChooseTable',
    defaultMessage: '请选择桌台',
  },
  gotoModify: {
    id: 'shoppingCart.gotoModify',
    defaultMessage: '去修改',
  },
  confirmTheOrder: {
    id: 'shoppingCart.confirmTheOrder',
    defaultMessage: '确认订单',
  },
  chooseJoinOrder: {
    id: 'shoppingCart.chooseJoinOrder',
    defaultMessage: '选择加入的订单',
  },
  sureOrder: {
    id: 'shoppingCart.sureOrder',
    defaultMessage: '确定下单',
  },
  createMyOrder: {
    id: 'shoppingCart.createMyOrder',
    defaultMessage: '创建我自己的订单',
  },
  createTime: {
    id: 'shoppingCart.createTime',
    defaultMessage: '创建时间',
  },
  allDishNum: {
    id: 'shoppingCart.allDishNum',
    defaultMessage: '共{allDishNum}份菜',
  },
  singleDiscountWithoutReduce: {
    id: 'shoppingCart.singleDiscountWithoutReduce',
    defaultMessage: '满减与折扣/第二份半价商品不同享',
  },
  singleDiscountWithReduce: {
    id: 'shoppingCart.singleDiscountWithReduce',
    defaultMessage: '折扣商品每单限购1份，超出部分按原价购买',
  },
  orderIsLocked: {
    id: 'orderIsLocked',
    defaultMessage: '订单已经锁定',
  },
  tinyCartUpTo: {
    id: 'tinyCartUpTo',
    defaultMessage: '起',
  },
  mustOrderTip: {
    id: 'shoppingCart.mustOrderTip',
    defaultMessage: '下单必须添加必点菜哦',
  },
  goAddMustOrder: {
    id: 'shoppingCart.goAddMustOrder',
    defaultMessage: '去添加',
  },
  dishesLoading: {
    id: 'shoppingCart.dishesLoading',
    defaultMessage: '拼命加载商品中~',
  },
});



// WEBPACK FOOTER //
// ./src/intl/messages/shopping-cart/index.js